import { render, staticRenderFns } from "./TipoPessoaSelect.vue?vue&type=template&id=64665753&"
import script from "./TipoPessoaSelect.vue?vue&type=script&lang=js&"
export * from "./TipoPessoaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports